import { render, staticRenderFns } from "./PostMenu.vue?vue&type=template&id=4139380c&scoped=true"
import script from "./PostMenu.vue?vue&type=script&lang=js"
export * from "./PostMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4139380c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4139380c')) {
      api.createRecord('4139380c', component.options)
    } else {
      api.reload('4139380c', component.options)
    }
    module.hot.accept("./PostMenu.vue?vue&type=template&id=4139380c&scoped=true", function () {
      api.rerender('4139380c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stickerMenu/PostMenu.vue"
export default component.exports